/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Revoked_ToastInputs */

const vi_shop_account_revoked_toast = /** @type {(inputs: Shop_Account_Revoked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng xuất khách khỏi mọi thiết bị.`)
};

/**

* @param {Shop_Account_Revoked_ToastInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_revoked_toast = /** @type {((inputs?: Shop_Account_Revoked_ToastInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Revoked_ToastInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_revoked_toast(inputs)
});